module.exports = __webpack_public_path__ + "img/sh-hl.9777e158.svg";